export default "__VITE_ASSET__BmUGyXZP__"